import React, { FunctionComponent } from "react";

import { MenuNavigationSectionType } from "../../navigation";
import { FormList } from "../FormList";
import { MenuComponent } from "../MenuComponent";
import { MenuTitle } from "../MenuTitle";

export type SubmenuComponentProps = {
    /** Identifikátor podmenu */
    submenuId: number;
    /** Nadpis podmenu */
    title: string | undefined;
};

/** Komponenta reprezentuje podmenu. Umožňuje práci s položkami menu či otevírání dalších podmenu. */
export const SubmenuComponent: FunctionComponent<SubmenuComponentProps> = ({
    submenuId,
    title,
}) => (
    <MenuComponent
        hasSubmenuBackground={true}
        headerContent={title && (
            <MenuTitle text={title} />
        )}
    >
        <FormList subtreeRootId={submenuId} section={MenuNavigationSectionType.forms} />
    </MenuComponent>
);
